<mat-card *ngIf="contact">
    <mat-card-title class="font-weight-bold caption-color">Contact Information

     
    </mat-card-title>
    <mat-divider></mat-divider>
     <mat-card-content class="pt-2 ">  <!--text-uppercase class remove by rahul yadav  -->
        <div class="row">
            <div class="col-sm-3 ">Sale Code</div>
            <span class="col-sm-1"> : </span>
            <div class="col-sm-8 font-weight-bold">
                <b *ngIf="contact.saleCode">{{contact.saleCode}}</b>
                <b><span class="blink_me" *ngIf="!contact.saleCode">New Contact</span></b>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3 ">Company Name</div>
            <span class="col-sm-1"> : </span>
            <div class="col-sm-8 font-weight-bold">{{contact.companyName}}</div>
        </div>
        <div class="row">
            <div class="col-sm-3">Contact Name</div>
            <span class="col-sm-1"> : </span>
            <div class="col-sm-8 font-weight-bold">{{contact.contactName}}</div>
        </div>
        <div class="row">
            <div class="col-sm-3">Address </div>
            <span class="col-sm-1"> : </span>
            <div class="col-sm-8 font-weight-bold text-info">
                <div> {{contact.address1}}</div>
                <div> {{contact.address2}}</div>
                <div> {{contact.address3}} , {{contact.cityDesc}} - {{contact.pinCode}}</div>
                <div> {{contact.satateDesc}} , {{contact.countryDesc}}</div>

            </div>
        </div>
        <div class="row" *ngIf="contact.mobileno && contact.mobileno!=0">
            <div class="col-sm-3">Mobile No.</div>
            <span class="col-sm-1"> : </span>
            <div class="col-sm-8 font-weight-bold">{{contact.mobileno}}</div>
        </div>
        <div class="row" *ngIf="contact.email">
            <div class="col-sm-3">Email</div>
            <span class="col-sm-1"> : </span>
            <div class="col-sm-8 font-weight-bold">{{contact.email}}</div>
        </div>
        <div class="row" *ngIf="contact.greenSector">
            <div class="col-sm-3">Green Sector</div>
            <span class="col-sm-1"> : </span>
            <div class="col-sm-8 font-weight-bold">{{contact.greenSector}}</div>
        </div>

        <div class="row" *ngIf="contact.segment">
            <div class="col-sm-3">Segment</div>
            <span class="col-sm-1"> : </span>
            <div class="col-sm-8 font-weight-bold">{{contact.segment}}</div>
        </div>
        <div class="row" *ngIf="contact.gstregistered">
            <div class="col-sm-3">GST Status</div>
            <span class="col-sm-1"> : </span>
            <div class="col-sm-8 font-weight-bold">{{contact.gstregistered}}</div>
        </div>
        <div class="row" *ngIf="contact.gstnumber">
            <div class="col-sm-3">GST No</div>
            <span class="col-sm-1"> : </span>
            <div class="col-sm-8 font-weight-bold">{{contact.gstnumber}}</div>
        </div>
        <div class="row" *ngIf="contact.saleRank || contact.serviceRank">
            <div class="col-sm-3">Rank (Sale/Service)</div>
            <span class="col-sm-1"> : </span>
            <div class="col-sm-8 font-weight-bold">{{contact.saleRank}} / {{contact.serviceRank}}</div>
        </div>
    </mat-card-content>

</mat-card>